import { render, staticRenderFns } from "./ad-list.vue?vue&type=template&id=bce64014&"
import script from "./ad-list.vue?vue&type=script&lang=js&"
export * from "./ad-list.vue?vue&type=script&lang=js&"
import style0 from "./ad-list.vue?vue&type=style&index=0&id=bce64014&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports